import React, { useEffect, useState } from "react";
import SectionKelola from "../../../components/CrudUserSetup/SectionKelola";
import ConfirmDialog from "../../../components/Feedback/ConfirmDialog";
import AlertDialog from "../../../components/Feedback/AlertDialog";

import {
  getAllTypeVarieties,
  createTypeVariety,
  updateTypeVariety,
  deleteTypeVariety,
} from "../../../services/TypeVarieties";

const VarietasSetup = () => {
  const [varietas, setVarietas] = useState([]);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  // 🔹 Ambil data varietas dari API
  useEffect(() => {
    const fetchVarietas = async () => {
      try {
        const data = await getAllTypeVarieties();
        setVarietas(data);
      } catch (err) {
        console.error("Gagal memuat varietas singkong:", err);
      }
    };

    fetchVarietas();
  }, []);

  // 🔹 Tambah varietas
  const handleAddVarietas = async (name) => {
    try {
      const response = await createTypeVariety({ name });
      const newItem = response.data?.data || response.data;
      setVarietas((prev) => [newItem, ...prev]);
      setAlertMessage("Varietas singkong berhasil ditambahkan!");
      setIsAlertOpen(true);
    } catch (err) {
      console.error("Gagal menambah varietas singkong:", err);
    }
  };

  // 🔹 Edit varietas
  const handleEditVarietas = async (item) => {
    try {
      const response = await updateTypeVariety(item.id, { name: item.name });
      const updated = response.data?.data || response.data;
      setVarietas((prev) =>
        prev.map((v) => (v.id === updated.id ? updated : v))
      );
      setAlertMessage("Varietas singkong berhasil diperbarui!");
      setIsAlertOpen(true);
    } catch (err) {
      console.error("Gagal mengedit varietas singkong:", err);
    }
  };

  // 🔹 Hapus varietas (pakai dialog konfirmasi)
  const handleConfirmDelete = async () => {
    if (!selectedDeleteItem) return;
    try {
      await deleteTypeVariety(selectedDeleteItem.id);
      setVarietas((prev) => prev.filter((v) => v.id !== selectedDeleteItem.id));
      setAlertMessage("Varietas singkong berhasil dihapus!");
      setIsAlertOpen(true);
    } catch (err) {
      console.error("Gagal menghapus varietas singkong:", err);
    } finally {
      setIsConfirmOpen(false);
      setSelectedDeleteItem(null);
    }
  };

  return (
    <div className="pt-10 pb-10 pl-64 pr-6">
      <h1 className="mb-6 text-2xl font-bold text-green-800">
        Manajemen Varietas Singkong
      </h1>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
        <SectionKelola
          title="Jenis Varietas Singkong"
          data={varietas}
          onAdd={handleAddVarietas}
          onDelete={(item) => {
            setSelectedDeleteItem(item);
            setIsConfirmOpen(true);
          }}
          onEdit={handleEditVarietas}
        />
      </div>

      {/* Confirm Delete */}
      <ConfirmDialog
        isOpen={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={handleConfirmDelete}
        title="Hapus Data"
        message="Apakah Anda yakin ingin menghapus varietas singkong ini?"
      />

      {/* Alert */}
      {isAlertOpen && (
        <AlertDialog
          isOpen={isAlertOpen}
          onClose={() => setIsAlertOpen(false)}
          title="Berhasil"
          message={alertMessage}
        />
      )}
    </div>
  );
};

export default VarietasSetup;
